import { render, staticRenderFns } from "./h5.vue?vue&type=template&id=5e1af206&"
import script from "./h5.vue?vue&type=script&lang=js&"
export * from "./h5.vue?vue&type=script&lang=js&"
import style0 from "./h5.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports